<template>
  <Breadcrumbs title="" main="Pages" />
  <div class="container-fluid" >
    <div class="col-sm-12" v-if="this.status ==='INITIAL' || this.status ==='PAID'">
      
      <div class="card">
        <div class="card-header">
          <div class="d-flex justify-content-center">
              <figure class="col-xl-12 col-sm-12">
                <img :src="this.order_obj.coverurl" style="width: 100%; border-radius: 4px; box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);" alt="Image description" />
              </figure>
    </div>
          <h3>{{this.currentLanguage ==='en'?'Step':'ขั้นตอนการสมัคร'}}</h3>
          <div class="stepper-wrapper">
            <div class="stepper-item completed">
              <div class="step-counter">1</div>
              <div class="step-name">{{this.currentLanguage ==='en'?'Infomation':'ข้อมูลผู้สมัคร'}}</div>
            </div>
            <div class="stepper-item completed">
              <div class="step-counter">2</div>
              <div class="step-name">{{this.currentLanguage ==='en'?'Address':'ข้อมูลที่อยู่'}}</div>
            </div>
            <div class="stepper-item" v-if="this.order_obj.status === 'INITIAL'&& this.order_obj.payment_method !== 'DIRECT'">
              <div class="step-counter">3</div>
              <div class="step-name">{{this.currentLanguage ==='en'?'Payment':'ชำระเงิน'}}</div>
            </div>
            <div class="stepper-item" v-if="this.order_obj.status === 'INITIAL'&& this.order_obj.payment_method === 'DIRECT'">
              <div class="step-counter">3</div>
              <div class="step-name">{{this.currentLanguage ==='en'?'Waiting payment slip checking':'รอตรวจสอบสลิปโอนเงิน'}}</div>
            </div>
            <div class="stepper-item" v-if="this.order_obj.status === 'INITIAL'">
              <div class="step-counter">4</div>
              <div class="step-name">{{this.currentLanguage ==='en'?'Completed':'เสร็จสมบูรณ์'}}</div>
            </div>
            <div class="stepper-item completed" v-if="this.order_obj.status === 'PAID'">
              <div class="step-counter">3</div>
              <div class="step-name">{{this.currentLanguage ==='en'?'Payment':'ชำระเงิน'}}</div>
            </div>
            <div class="stepper-item completed" v-if="this.order_obj.status === 'PAID'">
              <div class="step-counter">4</div>
              <div class="step-name">{{this.currentLanguage ==='en'?'Completed':'เสร็จสมบูรณ์'}}</div>
            </div>
          </div>
          <p>&nbsp;</p>
          <div class="d-flex justify-content-center">
            <h4>{{this.currentLanguage ==='en'?'OrderID:':'เลขที่ใบสมัคร:'}} {{ this.order_uuid }}</h4>
          </div>

          <div class="row" v-if="this.order_obj === null">
            <div class="d-flex justify-content-center w-100">
              <div class="order-skeleton order-skeleton-status"></div>
            </div>
          </div>

          <div class="row" v-if="this.order_obj">
            <div class="d-flex justify-content-center" v-if="this.order_obj.payment_method !== 'FREE'">
              <div v-if="this.status === null" class="order-skeleton order-skeleton-status"></div>
              <h4 v-if="this.status === 'INITIAL' && this.order_obj.payment_method !== 'DIRECT'" style="color: red">
                {{this.currentLanguage ==='en'?'Status: Wait for payment':'สถานะ: รอชำระเงิน'}}
              </h4>
              <h4 v-if="this.status === 'INITIAL' && this.order_obj.payment_method === 'DIRECT'" style="color: red">
                {{this.currentLanguage ==='en'?'Status: Waiting payment slip checking':'สถานะ: รอตรวจสอบสลิปโอนเงิน'}}
              </h4>
              <h4 v-if="this.status === 'PAID'" style="color: green">
                <vue-feather stroke="green" type="check-circle" size="20"> </vue-feather> {{this.currentLanguage ==='en'?'Status: Payment completed':'สถานะ: ชำระเงินเรียบร้อย'}}
              </h4>
            </div>
            <div class="d-flex justify-content-center" v-if="this.order_obj.payment_method === 'FREE'">
              <div v-if="this.status === null" class="order-skeleton order-skeleton-status"></div>
              <h4 style="color: green"><vue-feather stroke="green" type="check-circle" size="20"> </vue-feather> {{this.currentLanguage ==='en'?'Registration completed':'ลงทะเบียนเรียบร้อย'}} <span v-if="this.order_obj.is_event_lotto === 'Y'">[สุ่ม]</span></h4>
            </div>

            <div v-if="this.order_obj.payment_method !== 'FREE'" > 
              <div class="d-flex justify-content-center">
                <table class="table align-to-right payment-summary-table">
                  <tbody>
                    <tr >
                      <th class="payment-label">{{this.currentLanguage ==='en'?'Payment channels':'ช่องทางการชำระเงิน'}}:</th>
                      <th v-if="this.order_obj.is_free_payment_fee === 'N'" class="payment-value">{{ this.order_obj.payment_method==='PP_OPN'?"Promptpay (3%)":this.order_obj.payment_method==='CC_OPN'?"Credit Card (5%)":"Bank transfer (0%)" }}</th>
                      <th v-if="this.order_obj.is_free_payment_fee === 'Y'" class="payment-value">{{ this.order_obj.payment_method==='PP_OPN'?"Promptpay":this.order_obj.payment_method==='CC_OPN'?"Credit Card":"Bank transfer" }}</th>

                    </tr>
                    <tr >
                      <th class="payment-label">{{this.currentLanguage ==='en'?'Register amount':'ค่าสมัคร'}}:</th>
                      <th class="payment-value">{{ Number(this.order_obj.amount)-Number(this.order_obj.system_fee_amt) }} THB</th>
                    </tr>
                    <tr style="margin: 0px;" v-if="this.order_obj.is_system_fee==='Y'">
                      <th class="payment-label">{{this.currentLanguage ==='en'?'Register fee':'ค่าบริการระบบรับสมัคร'}}: </th>
                      <th class="payment-value">{{ Number(this.order_obj.system_fee_amt).toFixed(2) }} THB</th>
                    </tr>
                    <tr style="margin: 0px;">
                      <th class="payment-label">{{this.currentLanguage ==='en'?'Payment fee':'ค่าธรรมเนียมการชำระเงินออนไลน์'}}: </th>
                      <th class="payment-value">{{ Number(this.paid_amount-this.order_obj.amount).toFixed(2) }} THB</th>
                    </tr>
                    <tr class="payment-total-row">
                      <th class="payment-label"><b>{{this.currentLanguage ==='en'?'Total amount':'รวมยอด'}}: </b></th>
                      <th class="payment-value"><b>{{ this.paid_amount }} THB</b></th>
                    </tr>
                 </tbody>
              </table>
              </div>
              
            </div>
            <div style="border-radius: 5px;padding-bottom: 10px;text-decoration: underline;" v-if="this.order_obj.payment_method === 'FREE'" class="d-flex justify-content-center">
              <h5>{{ this.order_obj.remark	}}</h5>
            </div> 
            <div v-if="this.order_obj.payment_method === 'FREE'" class="d-flex justify-content-center">
              <b>{{this.currentLanguage ==='en'?'Registration date':'วันที่ลงทะเบียน'}}: {{ this.order_obj.create_date_txt	}}</b>
            </div>
            <div v-if="this.order_obj.payment_method === 'PP_OPN' || this.order_obj.payment_method === 'CC_OPN'" class="d-flex justify-content-center mt-3">
              <button
                type="button"
                class="btn btn-sm receipt-download-button"
                :disabled="this.status !== 'PAID'"
                :title="this.status !== 'PAID' ? (currentLanguage === 'en' ? 'Available after payment is completed' : 'สามารถดาวน์โหลดได้หลังชำระเงินเรียบร้อย') : ''"
                @click="downloadReceipt">
                <span class="receipt-download-icon"><vue-feather type="download" size="16"></vue-feather></span>
                <span >{{ currentLanguage === 'en' ? 'Download receipt' : 'ดาวน์โหลดใบเสร็จ' }}</span>
              </button>
            </div>
            

            <div class="row" v-if="this.order_obj.payment_method === 'FREE' || this.status === 'PAID'">
              <div class="col-12">
                <div class="qr-panel">
                  <h5 class="qr-panel-title">{{this.currentLanguage ==='en'?'Scan QR Code to open this page':'สแกน QR Code เพื่อเปิดหน้านี้'}}</h5>
                  <p class="qr-panel-subtitle">{{this.currentLanguage ==='en'?'Share this link with friends or scan directly from another device.':'แชร์ลิงก์นี้ให้เพื่อน หรือใช้มือถืออีกเครื่องสแกนได้ทันที'}}</p>
                  <a class="qr-panel-link" :href="this.qr_code" target="_blank">{{ this.qr_code }}</a>
                  <div class="qr-panel-actions">
                    <button type="button" class="btn btn-primary btn-sm qr-share-btn" @click="shareOrderLink">
                      <vue-feather type="share-2" size="14"></vue-feather>
                      {{this.currentLanguage ==='en'?'Share':'แชร์'}}
                    </button>
                  </div>
                  <div class="qr-panel-canvas">
                    <div class="qr-panel-canvas-inner">
                      <vue-qrcode
                        :value="this.qr_code"
                        :options="{
                          errorCorrectionLevel: 'high',
                          width: 300,
                          quality: 0.99,
                        }"
                      ></vue-qrcode>
                    </div>
                  </div>
                </div>
              </div>
            </div>

                       

            <div class="row" v-if="this.order_obj.payment_method === 'DIRECT'">
              
              <div class="row">
                <h4>{{this.currentLanguage ==='en'?'Account Infomation':'ข้อมูลบัญชีสำหรับโอนเงิน'}}</h4>
              </div>
              
              <div class="row">
                <div class="col-sm-12 col-lg-6 col-xl-4">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" disabled :value="this.order_obj.payment_account_no"
                      id="floatingInput" />
                    <label for="floatingInput">{{this.currentLanguage ==='en'?'Account no':'หมายเลขบัญชี'}}</label>
                  </div>
                </div>

                <div class="col-sm-12 col-lg-6 col-xl-4">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" disabled :value="this.order_obj.payment_account_name"
                      id="floatingInput" />
                    <label for="floatingInput">{{this.currentLanguage ==='en'?'Account name':'ชื่อบัญชี'}}</label>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-6 col-xl-4">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" disabled :value="this.order_obj.payment_bank_name"
                      id="floatingInput" />
                    <label for="floatingInput">{{this.currentLanguage ==='en'?'Bank':'ธนาคาร'}}</label>
                  </div>
                </div>
              </div>
              <div v-if="this.order_obj.qrcode_scan_url!==null" class="d-flex justify-content-center">
                     {{this.currentLanguage ==='en'?'Scan here':'หรือสแกนที่นี่'}}
              </div>
              <div v-if="this.order_obj.qrcode_scan_url!==null" class="d-flex justify-content-center">
                      <img style="width: 300px;"
                        :src="this.order_obj.qrcode_scan_url" alt="image slip" class="img-thumbnail" />
              </div>
              <p>&nbsp;</p>
              <hr>


              <form @submit="uploadSlip" class="needs-validation">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="d-flex justify-content-center">
                      <img v-if="this.order_obj.payment_slip_url === null" style="width: 300px;"
                        src="../../assets/images/running/receipt-slip.png" alt="image slip" class="img-thumbnail" />
                      <img v-else style="width: 300px;" :src="this.image_slip" alt="image slip" class="img-thumbnail" />
                    </div>
                    <div class="d-flex justify-content-center" v-if="this.order_obj.payment_slip_url === null">
                      <h5 style="color:red;">{{this.currentLanguage ==='en'?'upload payment slip and submit':'กรุณาเลือกไฟล์ เพื่ออัปโหลดสลิป ป้อนเวลา และกดปุ่ม [บันทึกข้อมูล]'}}  </h5>
                    </div>
                    <div class="d-flex justify-content-center" v-if="this.order_obj.payment_slip_url !== null">
                      <h5 style="color:green;"><vue-feather stroke="green" type="check-circle" size="20"> </vue-feather>{{this.currentLanguage ==='en'?'Slip added wait for admin checking':'แนบสลิปเรียบร้อย รอเจ้าหน้าที่บัญชีตรวจสอบอีกครั้ง'}}  </h5>
                    </div>
                    <div class="d-flex justify-content-center" v-if="this.order_obj.payment_slip_url !== null">
                      <h5 style="color: green;">{{this.currentLanguage ==='en'?'Payment date':'เวลาที่โอนเงิน'}}: {{ this.order_obj.payment_slip_time }}</h5>
                    </div>
                  </div>
                  <br>&nbsp;
                  <div v-if="this.order_obj.status === 'INITIAL'" class="d-flex justify-content-center">
                 
                      <span>
                      <ul><vue-feather type="info" size="12"></vue-feather> <b>{{this.currentLanguage ==='en'?'Instructions':'คำแนะนำในการใช้งาน'}}</b></ul>
                      <li>{{this.currentLanguage ==='en'?'When the money has been transferred and the transfer slip has been uploaded':'เมื่อโอนเงินและ อัปโหลดสลิปโอนเงินเรียบร้อยแล้ว'}}
                      <u style="color: red;">{{this.currentLanguage ==='en'?'Please check the status again in about 1-2 business days':'กรุณาเข้ามาตรวจสอบสถานะอีกครั้งประมาณ 1-2 วันทำการ'}},</u>
                      {{this.currentLanguage ==='en'?'The system will change the status to Payment completed When admin has verified the information':'ระบบจะเปลี่ยนสถานะเป็น ชำระเงินสำเร็จ เมื่อเจ้าหน้าที่ตรวจสอบข้อมูลเรียบร้อย'}}
                      </li>
                      
                    <li>{{this.currentLanguage ==='en'?'If you forget your orderID or want to check later, you can check by "Find order" menu':'หากลืมรหัสคำสั่งซื้อ หรือต้องการเข้ามาตรวจสอบภายหลัง สามารถค้นหาได้ที่เมนู ค้นหาใบสมัคร'}} </li>
                      </span>
                  </div>
                   
                  <form v-if="this.order_obj.status === 'INITIAL'" @submit.prevent="upload_slip"
                    class="needs-validation">
                    <div class="d-flex justify-content-center">
                      <div class="form-floating mb-3">
                        <input type="file" id="fileSlip"  accept="image/png, image/jpeg" class="form-control" />
                        <label for="fileSlip">{{this.currentLanguage ==='en'?'Choose a slip':'เลือกรูปสลิป'}}</label>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center">
                      <div class="form-floating mb-1">
                        <input placeholder="06:00" type="text" maxlength="5" v-model="payment_slip_time" id="payment_slip_time" class="form-control" />
                        <label for="image_slip_time">{{this.currentLanguage ==='en'?'transfer time':'เวลาโอนเงิน'}} HH:mm</label>
                      </div>
                    </div>
                   
                    <div class="col-sm-12">
                      <div class="d-flex justify-content-center">
                        <button 
                          type="submit" 
                          class="btn btn-lg" 
                          :style="{ 
                            cursor: isUploading ? 'not-allowed' : 'pointer',
                            backgroundColor: isUploading ? 'gray' : '',
                            borderColor: isUploading ? 'gray' : '',
                            color: isUploading ? 'white' : ''
                          }" 
                          :class="{ 'btn-primary': !isUploading }"
                          :disabled="isUploading">
                          [ <vue-feather type="save" size="18"></vue-feather> {{this.currentLanguage ==='en'?'Submit':'บันทึกข้อมูล'}} ]
                        </button>
                        &nbsp;
                        <!-- <button style="cursor: pointer" type="reset" class="btn btn-secondary btn-lg">
                          ยกเลิก
                        </button> -->
                      </div>
                      
                      <!-- Upload Progress Indicator -->
                      <div v-if="isUploading" class="d-flex justify-content-center mt-3">
                        <div class="text-center">
                          <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          <div class="mt-2">
                            <h5 style="color: #0d6efd;">
                              {{this.currentLanguage ==='en'?'Uploading':'กำลังอัปโหลด'}}... {{ uploadProgress }}%
                            </h5>
                            <div class="progress" style="height: 25px; width: 300px;">
                              <div 
                                class="progress-bar progress-bar-striped progress-bar-animated" 
                                role="progressbar" 
                                :style="{ width: uploadProgress + '%' }"
                                :aria-valuenow="uploadProgress" 
                                aria-valuemin="0" 
                                aria-valuemax="100">
                                {{ uploadProgress }}%
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </form>
            </div>
                         
            <div class="row" v-if="this.order_obj.status === 'INITIAL' && this.order_obj.payment_method === 'PP_OPN'">
              <p>&nbsp;</p>
              <div class="row">
                <div class="col-sm-12">
                  <div class="d-flex justify-content-center">
                    <img v-if="this.order_obj.payment_slip_url === null" style="width: 220px;"
                      :src="this.order_obj.qrcode_url" />
                    <img v-else style="width: 300px;" :src="this.image_slip" />
                  </div>
                </div>
                <div class="col-xl-12" style="text-align: center;">
                  <b style="color: red;"> QRCode จะหมดอายุภายใน 1 วัน หลังจากที่สร้างออร์เดอร์ </b><br>
                  กรุณาสแกนจ่ายให้เรียบร้อยก่อน QRCode หมดอายุ <span style="color: red;text-decoration-line: underline;">หากเกินนี้ต้องสร้างออร์เดอร์ใหม่อีกครั้ง</span><br>
                  
                  <p>
                    เวลาที่สร้างออร์เดอร์: {{ this.order_obj.create_date_txt }}
                  </p>
                  
                </div>
                <div class="d-flex justify-content-center" v-if="this.order_obj.status === 'INITIAL' && this.order_obj.payment_method === 'PP_OPN'">
                  <p >
                    <i class="fa fa-info-circle"></i>
                     {{this.currentLanguage ==='en'?" If using on a mobile phone device You can take a screenshot and scan the QRCode to pay with PromptPay":" หากใช้งานบนอุปกรณ์โทรศัพท์มือถือ สามารถแคปหน้าจอ เพื่อเอา QRCode ไปสแกนจ่ายพร้อมเพย์ได้เลย"}} 
                     <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.currentLanguage ==='en'?"If you have problems using it, you can ask for more information at the page:":"ติดปัญหาในการใช้งานสามารถสอบถามข้อมูลเพิ่มเติมได้ที่เพจ:"}}
                    <a target="_blank" href="https://www.facebook.com/runrace.in.th">RUNRACE ระบบรับสมัครงานวิ่ง</a><br /></p>
                 
                </div>
                <div class="d-flex justify-content-center">
                  <a class="btn btn-primary btn" href="" role="button">
                    <vue-feather type="refresh-cw" size="18"> </vue-feather>
                    {{this.currentLanguage ==='en'?'Refresh when payment is complete':'กดปุ่ม Refresh เมื่อชำระเงินเรียบร้อย'}}</a>
                </div>
              </div>
            </div>
            <div class="row" v-if="this.order_obj.status === 'INITIAL' && this.order_obj.payment_method === 'CC_OPN'">
              <div  class="d-flex justify-content-center">
                    <form id="checkout-form" style="padding-top: 10px;">
                      <button 
                        type="button"
                        @click.prevent="ccpayment"
                        id="checkout-button"
                        class="btn btn-primary"
                      >
                        {{ "PAY NOW " + this.order_obj.paid_amount + " THB" }}
                      </button>
                    </form>
                  </div>
                  <div  class="d-flex justify-content-center">
                    <i class="fa fa-info-circle"></i>&nbsp; {{this.currentLanguage ==='en'?'Click PAY NOW to payment':'กดที่ PAY NOW เพื่อชำระเงิน'}}
                  </div>
                  
            </div>
          
          </div>
           <div class="card-body" v-if="this.order_obj.status === 'PAID' && this.order_obj.is_enable_refund === 'Y'">  
              <h4 >{{this.currentLanguage ==='en'?'Refund (Submit Request)':'ข้อมูลการคืนเงิน(ยื่นคำขอ)'}} </h4>
              <p v-if="this.order_obj.refund_status === 'I'">🗓️ ขั้นตอนการยื่นขอคืนเงิน กรุณาอ่านทำความเข้าใจก่อนเริ่มดำเนินการ:<br>
                &nbsp;&nbsp;&nbsp;1.ป้อนข้อมูลการโอนเงินให้ครบถ้วน <br> 
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;📌 ข้อมูลชื่อบัญชี ( <span style="color: red;">ชื่อบัญชีต้องตรงกับผู้สมัครคนใดคนหนึ่งของ ด้านล่างนี้เท่านั้น</span> )<br> 
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*หากไม่ตรง กรุณา <br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✅ป้อนข้อมูลคำอธิบายในช่องหมายเหตุ โดยจะต้องมีข้อมูลชื่อ Facebook ที่ใช้ในการติดต่อ <br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✅ส่งข้อมูลรูปบัตรประชาชนตัวจริง <span style="color: red;">ผู้รับเงินคืน(เจ้าของบัญชี)</span> <br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✅ส่งข้อมูลรูปบัตรประชาชนตัวจริง <span style="color: red;">ผู้สมัคร(นักกีฬา)</span> <br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✅สลิปโอนเงิน <br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✅เลขที่ใบสมัคร: {{ this.order_obj.uuid }} <br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; เพื่อแจ้งความประสงค์ที่ Facebook: <a target="_blank" href="https://www.facebook.com/profile.php?id=61586384939970">Korat Underground Run 2026 เดิน-วิ่ง ทะลุอุโมงค์</a> <br>
                &nbsp;&nbsp;&nbsp;2.กดปุ่ม "ยืนยันการขอคืนเงิน"<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;📌 กรุณาตรวจสอบความถูกต้องของข้อมูลก่อนการบันทึก เนื่องจากหากบันทึกข้อมูลแล้ว จะไม่สามารถแก้ไขได้
                
              </p>

              <div class="col-sm-12">
                <form @submit.prevent="submit_refund_request" class="needs-validation">
                <div class="row" v-if="this.order_obj.refund_status === 'I'">
                  <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" minlength="5" maxlength="40"  required v-model="refund_account_name" class="form-control" id="refund_account_name">
                          <label for="refund_account_name">{{this.currentLanguage ==='en'?'Account Name must match one of the applicants below':'ชื่อบัญชี ต้องตรงกับชื่อผู้สมัครคนใดคนหนึ่งด้านล่างนี้เท่านั้น'}} <span style="color: red;font-size: large;">*</span></label>
                        </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" minlength="6" maxlength="30"  required v-model="refund_account_no" class="form-control" id="refund_account_no">
                          <label for="refund_account_no">{{this.currentLanguage ==='en'?'Account Number (no dashes)':'หมายเลขบัญชี (ไม่ต้องมีขีด)'}} <span style="color: red;font-size: large;">*</span></label>
                        </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                           <select class="form-select" required v-model="refund_account_bank" id="refund_account_bank" >
                            <option value="" disabled selected>กรุณาเลือกธนาคาร</option>
                            
                            <option value="ธนาคารกรุงเทพ">ธนาคารกรุงเทพ (BBL)</option>
                            <option value="ธนาคารกสิกรไทย">ธนาคารกสิกรไทย (KBANK)</option>
                            <option value="ธนาคารกรุงไทย">ธนาคารกรุงไทย (KTB)</option>
                            <option value="ธนาคารไทยพาณิชย์">ธนาคารไทยพาณิชย์ (SCB)</option>
                            <option value="ธนาคารกรุงศรีอยุธยา">ธนาคารกรุงศรีอยุธยา (BAY)</option>
                            <option value="ธนาคารทหารไทยธนชาต">ธนาคารทหารไทยธนชาต (ttb)</option>
                            <option value="ธนาคารยูโอบี">ธนาคารยูโอบี (UOB)</option>
                            <option value="ธนาคารออมสิน">ธนาคารออมสิน (GSB)</option>
                            <option value="ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร">ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (BAAC)</option>
                            <option value="ธนาคารอาคารสงเคราะห์">ธนาคารอาคารสงเคราะห์ (GHB)</option>
                            <option value="ธนาคารอิสลามแห่งประเทศไทย">ธนาคารอิสลามแห่งประเทศไทย (ibank)</option>
                            <option value="ธนาคารเกียรตินาคินภัทร">ธนาคารเกียรตินาคินภัทร (KKP)</option>
                            <option value="ธนาคารทิสโก้">ธนาคารทิสโก้ (TISCO)</option>
                            <option value="ธนาคารซีไอเอ็มบี ไทย">ธนาคารซีไอเอ็มบี ไทย (CIMBT)</option>
                            <option value="ธนาคารแลนด์ แอนด์ เฮ้าส์">ธนาคารแลนด์ แอนด์ เฮ้าส์ (LHBANK)</option>
                            <option value="ธนาคารไทยเครดิต">ธนาคารไทยเครดิต (Thai Credit)</option>
                            <option value="ธนาคารไอซีบีซี (ไทย)">ธนาคารไอซีบีซี (ไทย) (ICBC)</option>
                        </select>
                        <label for="refund_account_bank">{{this.currentLanguage ==='en'?'Bank Name':'ชื่อธนาคาร'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" minlength="10" maxlength="10"  required v-model="refund_mobile_no" class="form-control" id="refund_mobile_no">
                          <label for="refund_mobile_no">{{this.currentLanguage ==='en'?'Mobile Number':'หมายเลขโทรศัพท์'}} <span style="color: red;font-size: large;">*</span></label>
                        </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" v-model="refund_remark" class="form-control" id="refund_remark">
                          <label for="refund_remark">{{this.currentLanguage ==='en'?'Remark (If any)':'หมายเหตุ (ถ้ามี หากไม่มีให้เว้นว่าง)'}}</label>
                        </div>
                  </div>
                  <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" v-model="refund_amount" disabled class="form-control" id="refund_amount">
                          <label for="refund_amount">{{this.currentLanguage ==='en'?'Refund Amount (including fees)':'ยอดเงินที่ได้รับคืน (รวมค่าธรรมเนียม)'}}</label>
                        </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                  <div class="alert alert-light" role="alert">
                    <strong v-if="this.order_obj.refund_status === 'I'">กรุณาตรวจสอบความถูกต้องของข้อมูลก่อนการบันทึก</strong>
                    <div class="mt-2">
                    <div><strong>ชื่อบัญชี:</strong> {{ this.refund_account_name }}</div>
                    <div><strong>หมายเลขบัญชี:</strong> {{ this.refund_account_no }}</div>
                    <div><strong>ชื่อธนาคาร:</strong> {{ this.refund_account_bank }}</div>
                    <div><strong>หมายเลขโทรศัพท์:</strong> {{ this.refund_mobile_no }}</div>
                    <div><strong>หมายเหตุ:</strong> {{ this.refund_remark }}</div>
                    <div><strong>ยอดเงินที่ได้รับคืน (รวมค่าธรรมเนียม):</strong> {{ this.refund_amount }} THB</div> 
                    </div>
                  </div>
                  </div>
                  
                </div>
                <div class="row" v-if="this.order_obj.refund_status === 'I'">
                  <div class="d-flex justify-content-center">
                    <b style="color: red;">{{this.currentLanguage ==='en'?'* Once submitted, the refund request cannot be changed. Please check the information carefully before submitting.':'* เมื่อยืนยันการขอคืนเงินแล้ว จะไม่สามารถแก้ไขข้อมูลได้ กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนกดยืนยัน'}}</b>
                    </div>
                </div>
                <div class="row" v-if="this.order_obj.refund_status === 'I'">
                  <div class="d-flex justify-content-center">
                    <button type="button" @click="submit_refund_request" style="cursor: pointer" class="btn btn-danger btn-lg">
                      [ <vue-feather type="rotate-ccw" size="18"></vue-feather> {{this.currentLanguage ==='en'?'Submit refund request':'ยืนยันการขอคืนเงิน'}} ]
                    </button>
                  </div>
                </div>
                <div class="row" v-if="this.order_obj.refund_status === 'REQUEST' || this.order_obj.refund_status === 'COMPLETED'">
                  <div class="stepper-wrapper">
                    <div class="stepper-item completed">
                      <div class="step-counter">
                        <vue-feather type="check" stroke="white" size="20"></vue-feather>
                      </div>
                      <div class="step-name">
                        {{this.currentLanguage ==='en'?'Open refund system':'เปิดระบบขอคืนเงิน'}}<br>
                        <small>05/02/2026 10:00</small>
                      </div>
                    </div>
                    <div class="stepper-item completed">
                      <div class="step-counter">
                        <vue-feather type="check" stroke="white" size="20"></vue-feather>
                      </div>
                      <div class="step-name">
                        {{this.currentLanguage ==='en'?'Refund request submitted':'ส่งคำขอคืนเงิน'}}<br>
                        <small>{{this.refund_create_date}}</small>
                      </div>
                    </div>
                    <div class="stepper-item" :class="{'completed': this.order_obj.refund_completed_date}">
                      <div class="step-counter">
                        <vue-feather v-if="this.order_obj.refund_completed_date" type="check" stroke="white" size="20"></vue-feather>
                        <span v-else>3</span>
                      </div>
                      <div class="step-name">
                        <span style="color: green;">{{this.currentLanguage ==='en'?'Refund completed':'โอนเงินคืนเรียบร้อย'}}</span><br>
                        <small style="color: green;" v-if="this.order_obj.refund_completed_date">{{this.order_obj.refund_completed_date}}</small>
                        <small v-else style="color: orange;">{{this.currentLanguage ==='en'?'Processing (7-15 days)':'กำลังดำเนินการ (7-15 วันทำการ)'}}</small>
                      </div>
                    </div>
                  </div>
                </div>

                


                </form>
              </div>

            </div>
          <hr>
          <div class="card-body">
            <h4>{{this.currentLanguage ==='en'?'Number of applicants info':'ข้อมูลผู้สมัครจำนวน'}} {{ this.runner_list.length }} {{this.currentLanguage ==='en'?'':'ท่าน'}}</h4>
            <p>&nbsp;</p>
            <div class="row">
              <div class="card" style="width: 18rem" v-for="(item, index) in this.runner_list" :key="index"
                :value="item.id_card">
                <div style="text-align: left">
                  <input class="form-check-input" v-model="is_main_register" disabled type="radio"
                    name="is_main_register" :id="'is_main_register' + item.id_card" :value="item.id_card" />
                  <label class="form-check-label" :for="'is_main_register' + item.id_card">
                    <p>&nbsp;{{this.currentLanguage ==='en'?'Main register':'ผู้สมัครหลัก'}}</p>
                  </label>
                </div>

                <img v-if="item.sex==='MALE'" src="../../assets/images/runner.jpg" class="card-img-top" alt="runner">
                <img v-if="item.sex==='FEMALE'" src="../../assets/images/runner-girl.jpg" class="card-img-top" alt="runner">
                <div class="card-body">
                  <h5 class="card-title">{{ item.fname }} {{ item.lname }}</h5>
                  <p class="card-text">
                    {{ item.run_type_name }}<br />
                    {{ item.run_type_price }} THB <br />
                    {{ item.run_type_description }}
                  </p>
                  <div style="align-items: center">
                    <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal"
                      :data-bs-target="'#' + item.id_card">
                      {{this.currentLanguage ==='en'?'Infomation':'ข้อมูลผู้สมัคร'}}
                    </button>
                  </div>

                  <div class="modal fade" :id="item.id_card" tabindex="-1" :aria-labelledby="item.id_card"
                    aria-hidden="true">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h1 class="modal-title fs-5" :id="item.id_card">
                            {{ item.fname }} {{ item.lname }}
                          </h1>
                          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          Order no: {{ this.order_obj.uuid }} <br />
                          .<br>
                          {{this.currentLanguage ==='en'?'name':'ชื่อ'}}: {{ item.fname }} {{ item.lname }} <br />
                          <template v-if="order_obj.is_store_name_en === 'Y'">
                            {{ currentLanguage === 'en' ? 'English name' : 'ชื่อภาษาอังกฤษ' }}: {{ item.fname_en || '-' }} {{ item.lname_en || '-' }} <br />
                          </template>
                          {{this.currentLanguage ==='en'?'gender':'เพศ'}}: {{ item.sex }} <br />
                          {{this.currentLanguage ==='en'?'dob':'วันเกิด'}}: {{ this.rr_user.is_show_data === 'Y' ? item.dob : item.dob.substring(0, 5) + '0*-**' }} <br />
                          {{this.currentLanguage ==='en'?'nationality':'สัญชาติ'}}: {{ item.nationality }} <br />
                          {{this.currentLanguage ==='en'?'id card/Passport':'เลขบัตรประชาชน/พาสปอร์ต'}}: {{ this.rr_user.is_show_data === 'Y' ? item.id_card : (item.id_card.length >= 6 ? '****' + item.id_card.substring(item.id_card.length-4, item.id_card.length) : '***'+item.id_card) }} <br />
                          <!-- หมายเลขโทรศัพท์: ****{{ item.mobile_no.length >= 6 ? item.mobile_no.substring(item.mobile_no.length-4, item.mobile_no.length):item.mobile_no }} <br /> -->
                          <!-- {{this.currentLanguage ==='en'?'mobile no':'หมายเลขโทรศัพท์'}}: {{ item.mobile_no }} <br /> -->
                          {{this.currentLanguage ==='en'?'mobile no':'หมายเลขโทรศัพท์'}}: {{ this.rr_user.is_show_data === 'Y' ? item.mobile_no : (item.mobile_no && item.mobile_no.length >= 8 ? item.mobile_no.slice(0, 8) + '***' : item.mobile_no+'***') }} <br />
                          {{this.currentLanguage ==='en'?'email':'อีเมลล์'}}: {{ this.rr_user.is_show_data === 'Y' ? item.email : (item.email && item.email.length >= 6 ? item.email.substring(0, 3) + '****' + item.email.substring(item.email.lastIndexOf('@')) : item.email)  }} <br>
                          {{this.currentLanguage ==='en'?'blood type':'หมู่เลือด'}}: {{ this.rr_user.is_show_data === 'Y' ? item.blood_group : '**' }} <br />
                          {{this.currentLanguage ==='en'?'emergency contact name':'ชื่อผู้ติดต่อกรณีฉุกเฉิน'}}: {{ this.rr_user.is_show_data === 'Y' ? item.emergency_name : (item.emergency_name && item.emergency_name.length >= 2 ? item.emergency_name.substring(0, 2) + '****' : item.emergency_name) }}<br />
                          {{this.currentLanguage ==='en'?'relationship':'ความสัมพันธ์'}}: {{ item.emergency_relation }} <br />
                          <!-- เบอร์โทรศัพท์ผู้ติดต่อกรณีฉุกเฉิน: ****{{ item.emergency_mobile_no.length >= 6 ? item.emergency_mobile_no.substring(item.emergency_mobile_no.length-4, item.emergency_mobile_no.length):item.emergency_mobile_no }}<br /> -->
                          {{this.currentLanguage ==='en'?'emergency contact mobile number':'เบอร์โทรศัพท์ผู้ติดต่อกรณีฉุกเฉิน'}}: {{ this.rr_user.is_show_data === 'Y' ? item.emergency_mobile_no : (item.emergency_mobile_no && item.emergency_mobile_no.length >= 8 ? item.emergency_mobile_no.slice(0, 8) + '***' : item.emergency_mobile_no+'***') }} <br>
                          {{this.currentLanguage ==='en'?'Type':'ประเภทการเเข่งขัน'}}: {{ item.run_type_name }}, {{ item.run_type_description }}, {{ item.run_type_price }} <br>
                          {{this.currentLanguage ==='en'?'Group':'รูปแบบการแข่งขัน'}}: {{ item.run_model_name }} <br>
                          {{this.currentLanguage ==='en'?'Team':'ชื่อทีม'}}: {{ item.runner_team }} <br>
                          {{this.currentLanguage ==='en'?'Shirt size':'ขนาดเสื้อ'}}: {{ item.t_shirt_name }}<br>
                          <span v-if="item.t_shirt_more_name">{{this.currentLanguage ==='en'?'Second shirt size':'ขนาดเสื้อตัวที่สอง'}}: {{ item.t_shirt_more_name }}<br></span>
                          {{this.currentLanguage ==='en'?'more':'เพิ่มเติม'}}: {{ item.additional1_name }}<br>
                          {{this.currentLanguage ==='en'?'more':'เพิ่มเติม'}}: {{ item.additional2_name }}
                          <div v-if="getTeamMemberDetails(item.team_member_obj).length > 0" class="mt-3 pt-3 border-top">
                            <b>{{ currentLanguage === 'en' ? 'Team members' : 'สมาชิกในทีม' }}</b>
                            <div v-for="(member, memberIndex) in getTeamMemberDetails(item.team_member_obj)" :key="`team-member-detail-${memberIndex}`" class="mt-2">
                              <b>{{ currentLanguage === 'en' ? `Team member ${memberIndex + 2}` : `สมาชิกในทีม คนที่${memberIndex + 2}` }}</b><br>
                              {{ currentLanguage === 'en' ? 'Name' : 'ชื่อ' }}: {{ member.fname }} {{ member.lname }}<br>
                              {{ currentLanguage === 'en' ? 'Gender' : 'เพศ' }}: {{ member.sex }}<br>
                              {{ currentLanguage === 'en' ? 'Date of birth' : 'วันเกิด' }}: {{ maskTeamDateOfBirth(member.dob) }}<br>
                              {{ currentLanguage === 'en' ? 'ID card/Passport' : 'เลขบัตรประชาชน/พาสปอร์ต' }}: {{ maskTeamIdCard(member.id_card) }}<br>
                              {{ currentLanguage === 'en' ? 'Mobile number' : 'หมายเลขโทรศัพท์' }}: {{ maskTeamMobileNumber(member.mobile_no) }}<br>
                              {{ currentLanguage === 'en' ? 'Blood group' : 'หมู่เลือด' }}: {{ rr_user.is_show_data === 'Y' ? member.blood_group : '**' }}<br>
                              {{ currentLanguage === 'en' ? 'Shirt size' : 'ขนาดเสื้อ' }}: {{ member.t_shirt_name }}<br>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            

            <h5>{{this.currentLanguage ==='en'?'Address':'ข้อมูลที่อยู่'}}</h5>
            <lu v-if="this.order_obj.delivery_type_is_require_address === 'Y'">
              
              <b>{{ this.order_obj.delivery_type_name }}:</b> 
                {{ this.order_obj.delivery_add_name }}
                {{ this.order_obj.delivery_add_mobile_no && this.order_obj.delivery_add_mobile_no.length >= 7 ? this.order_obj.delivery_add_mobile_no.slice(0, 8) + 'XXX' : this.order_obj.delivery_add_mobile_no }} <br />
                {{ this.order_obj.delivery_add_no }}
                {{ this.order_obj.delivery_add_sub_district }}
                {{ this.order_obj.delivery_add_district }}
                {{ this.order_obj.delivery_add_province }}
                {{ this.order_obj.delivery_add_postcode }}
              
            </lu>
            <lu v-if="this.order_obj.delivery_type_is_require_address !== 'Y'">
              
              <b>{{ this.order_obj.delivery_type_name }}:</b> {{ this.order_obj.runner_delivery_type_name }}
            </lu>
            <br>.<br>
            <div class="organizer-info-row">
              <div class="organizer-info-content">
                <div v-if="this.order_obj.organizer_info && this.currentLanguage==='th'" v-html="this.order_obj.organizer_info"></div>
                <div v-if="this.order_obj.organizer_info_en && this.currentLanguage==='en'" v-html="this.order_obj.organizer_info_en"></div>
              </div>
              <div
                v-if="order_obj.payment_method === 'PP_OPN' || order_obj.payment_method === 'CC_OPN'"
                class="receipt-page-note">
                <b>หมายเหตุ:</b>
                รับเงินแทน ผู้จัดงาน {{ order_obj.title || order_obj.event_key }} ตามข้อตกลงการเป็นตัวแทน เลขที่ rrc-{{ order_obj.event_key }}<br>
                เงินจำนวนดังกล่าวเป็นเงินที่รับแทนผู้จัดงาน มิใช่รายได้ของตัวแทน
              </div>
            </div>
            <p>&nbsp;</p>
            <hr>
            <div style="font-size: 10px;">
                <b>{{this.currentLanguage ==='en'?'Instructions':'ติดปัญหาการใช้งานระบบ'}}</b> <br>
                {{this.currentLanguage ==='en'?'If you forget your orderID or want to check later, you can find by "Find order" menu':'หากลืมรหัสคำสั่งซื้อ หรือต้องการเข้ามาตรวจสอบภายหลัง สามารถค้นหาได้ที่เมนู ค้นหาใบสมัคร'}}: <a target="_blank" href="https://runrace.in.th/find-order">ค้นหาใบสมัคร</a><br>
            {{this.currentLanguage ==='en'?'If you encounter any problems using the system or have any questions, please contact the system administrator at the following telephone number:':'พบปัญหาการใช้งานระบบ หรือมีข้อสงสัยที่เกี่ยวกับระบบ ติดต่อแอดมินดูแลระบบรับสมัครได้ที่ '}}<br>
             &nbsp;&nbsp;&nbsp;Facebook: <a href="https://www.facebook.com/runrace.in.th" target="_blank">RUNRACE ระบบรับสมัครงานวิ่ง</a> <br>
             &nbsp;&nbsp;&nbsp;Line Official: <a  target="_blank" href="https://lin.ee/lXoC4App">@892llvwo</a> <br>
             &nbsp;&nbsp;&nbsp;หมายเลขโทรศัพท์: 090-494998เก้า
            </div>
            
            
          </div>

        </div>
      </div>
    </div>

    <div class="col-sm-12" v-if="this.status ==='NOTFOUND'">
      <div class="card">
        <div class="d-flex justify-content-center" style="color: red;">
         *** You Do Not Have Permission To Access ***
        </div>
        
      </div>
    </div>
    <div class="col-sm-12" v-if="this.status ==='INITIAL_PAGE'">
      <div class="card">
        <div class="card-body order-skeleton-wrap">
          <div class="order-skeleton order-skeleton-cover mb-3"></div>
          <div class="order-skeleton order-skeleton-step mb-2"></div>
          <div class="order-skeleton order-skeleton-step mb-2"></div>
          <div class="order-skeleton order-skeleton-title mb-3"></div>
          <div class="order-skeleton order-skeleton-line mb-2"></div>
          <div class="order-skeleton order-skeleton-line order-skeleton-line-short"></div>
        </div>
      </div>
    </div>
    <p></p>
  </div>
  <p></p>
  <div id="receipt-pdf" class="receipt-pdf" v-if="order_obj && order_obj.uuid">
    <div class="receipt-pdf-header">
      <h2>{{ companyName }}</h2>
      <p v-if="companyTaxNo">เลขประจำตัวผู้เสียภาษี {{ companyTaxNo }}</p>
      <p v-if="companyAddress">{{ companyAddress }}</p>
      <h3>ใบเสร็จรับเงิน / ใบรับเงินแทน</h3>
    </div>
    <div class="receipt-pdf-row"><span>เลขที่ใบสมัคร / Order no.</span><b>{{ order_obj.uuid }}</b></div>
    <div class="receipt-pdf-row"><span>กิจกรรม / Event</span><b>{{ order_obj.title || order_obj.event_key }}</b></div>
    <div class="receipt-pdf-row"><span>วันที่ / Date</span><b>{{ order_obj.create_date_txt }}</b></div>
    <div class="receipt-pdf-row"><span>ค่าสมัคร / Registration fee</span><b>{{ receiptRegistrationAmount }} THB</b></div>
    <div class="receipt-pdf-row"><span>ค่าธรรมเนียมการรับชำระ / Collection fee</span><b>{{ receiptCollectionFee }} THB</b></div>
    <div class="receipt-pdf-row receipt-pdf-total"><span>รวมจำนวนเงิน / Total amount received</span><b>{{ receiptTotalAmount }} THB</b></div>
    <div class="receipt-pdf-note">
      <b>หมายเหตุ:</b><br>
      รับเงินแทน ผู้จัดงาน {{ order_obj.title || order_obj.event_key }} ตามข้อตกลงการเป็นตัวแทน เลขที่ rrc-{{ order_obj.event_key }}<br>
      เงินจำนวนดังกล่าวเป็นเงินที่รับแทนผู้จัดงาน มิใช่รายได้ของตัวแทน
    </div>
    <div class="receipt-pdf-signature">
      ลงชื่อ <img :src="receiptSignature" class="receipt-signature-image" alt="Signature"> ผู้รับเงิน<br>
      ({{ companyName }})
    </div>
  </div>
</template>

<script>

import axios from "axios";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import receiptSignature from "../../assets/images/receipt-signature.png";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "@sweetalert2/theme-bootstrap-4/bootstrap-4.scss";
let OmiseCard;
export default {
  setup() {   
  },
  data() {
    return {
      order_uuid: this.$route.params.q,
      order_id: null,
      event_key: null,
      runner_list: {},
      status: 'INITIAL_PAGE',
      paid_amount: null,
      order_obj: {},
      is_main_register: null,
      image_slip: null,
      payment_slip_time: null,
      s3_url: process.env.VUE_APP_AWS_S3_URL,
      companyName: process.env.VUE_APP_COMPANY_NAME || 'RUNRACE',
      companyTaxNo: process.env.VUE_APP_COMPANY_TAXNO || '',
      companyAddress: process.env.VUE_APP_COMPANY_ADDRESS || '',
      receiptSignature,
      opn_pk: process.env.VUE_APP_PAYMENT_OPN_AUTHORIZATION_PUBLIC_KEY,
      currentLanguage: 'th',
      refund_account_name: null,
      refund_account_no: null,    
      refund_account_bank: null,
      refund_mobile_no: null,
      refund_remark: null,
      refund_amount: null,
      refund_create_date: null,
      isUploading: false,
      uploadProgress: 0,
      qr_code: '-',
      rr_user: {
        role: null,
        is_show_data: 'N'
      },
      };
  },
  watch: {},
  async beforeCreate() {
    this.is_loading = "Y";
    this.order_uuid = this.$route.params.q;
    const data = {
      tk: process.env.VUE_APP_FN_TO_BK_SECRET_KEY,
      order_uuid: this.order_uuid,
    };

    const res = await axios.post("/v1/order/inquiry", data);
    //console.log("res:" + JSON.stringify(res));
    if (res.data.status === "success") {
      this.order_obj = res.data.body;
      this.is_main_register = this.order_obj.id_card;

      this.runner_list = JSON.parse(res.data.body.runner_json);
      this.status = res.data.body.status;
      this.paid_amount = res.data.body.paid_amount;
      if(this.order_obj.is_enable_refund === 'Y'){
        this.refund_account_no = this.order_obj.refund_account_no;
        this.refund_account_name = this.order_obj.refund_account_name;
        this.refund_account_bank = this.order_obj.refund_account_bank;
        this.refund_mobile_no = this.order_obj.refund_mobile_no;
        this.refund_remark = this.order_obj.refund_remark;
        this.refund_create_date = this.order_obj.refund_create_date_txt;

        if(this.order_obj.refund_status === 'I'){
          this.refund_account_name = this.order_obj.delivery_add_name;
          this.refund_mobile_no = this.order_obj.mobile;
        }
      }
      this.refund_amount = this.order_obj.paid_amount;
      if (this.order_obj.payment_slip_url === null) {

      } else {
        this.image_slip = process.env.VUE_APP_AWS_S3_URL + this.order_obj.payment_slip_url
      }

    } else {
      this.status = "NOTFOUND"
      await Swal.fire({
        position: "top-center",
        icon: "error",
        title:
          "พบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง, หรือติดต่อลูกค้าสัมพันธ์ที่ RUNRACE",
        showConfirmButton: true,
      });
    }
  },
  async beforeMount() {
    this.qr_code = "-";
  },
  mounted() {
    this.initialize();

    if(localStorage.getItem('currentLanguage') !== null){
      this.currentLanguage = localStorage.getItem('currentLanguage');
    }

    const _rr_user = localStorage.getItem("_rr_user");
    if(_rr_user !== null){
      this.rr_user = JSON.parse(_rr_user);
      if(this.rr_user.role === 'ssadmin' || this.rr_user.role === 'organizer'){
        this.rr_user.is_show_data = 'Y';
      }
    }

    this.qr_code = window.location.href;
  },  
  computed: {
    receiptRegistrationAmount() {
      return Number(this.order_obj.amount || 0).toFixed(2);
    },
    receiptCollectionFee() {
      return Math.max(Number(this.paid_amount || 0) - Number(this.order_obj.amount || 0), 0).toFixed(2);
    },
    receiptTotalAmount() {
      return Number(this.paid_amount || 0).toFixed(2);
    },
  },
  methods: {
    async downloadReceipt() {
      const receiptElement = document.getElementById('receipt-pdf');
      if (!receiptElement) {
        return;
      }

      const canvas = await html2canvas(receiptElement, {
        backgroundColor: '#ffffff',
        scale: 1.85,
      });
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        compress: true,
      });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imageHeight = (canvas.height * pageWidth) / canvas.width;
      const receiptImage = canvas.toDataURL('image/jpeg', 0.85);

      pdf.addImage(receiptImage, 'JPEG', 0, 0, pageWidth, imageHeight, undefined, 'FAST');
      if (imageHeight > pageHeight) {
        let heightLeft = imageHeight - pageHeight;
        let position = -pageHeight;
        while (heightLeft > 0) {
          pdf.addPage();
          pdf.addImage(receiptImage, 'JPEG', 0, position, pageWidth, imageHeight, undefined, 'FAST');
          heightLeft -= pageHeight;
          position -= pageHeight;
        }
      }
      pdf.save(`receipt-${this.order_obj.uuid}.pdf`);
    },
    getTeamMemberDetails(teamMemberObj) {
      if (!Array.isArray(teamMemberObj)) {
        return [];
      }
      return teamMemberObj.map((member) => {
        const legacyPrefix = member.t3_fname === undefined ? 't2' : 't3';
        return {
          fname: member.fname || member[`${legacyPrefix}_fname`] || '',
          lname: member.lname || member[`${legacyPrefix}_lname`] || '',
          sex: member.sex || member[`${legacyPrefix}_sex`] || '',
          dob: member.dob || member[`${legacyPrefix}_dob`] || '',
          id_card: member.id_card || member[`${legacyPrefix}_id_card`] || '',
          mobile_no: member.mobile_no || member[`${legacyPrefix}_mobile_no`] || '',
          blood_group: member.blood_group || member[`${legacyPrefix}_blood_group`] || '',
          t_shirt_name: member.t_shirt_name || member[`${legacyPrefix}_t_shirt_name`] || ''
        };
      });
    },
    maskTeamDateOfBirth(dob) {
      if (this.rr_user.is_show_data === 'Y') {
        return dob;
      }
      return dob ? `${dob.substring(0, 5)}0*-**` : '';
    },
    maskTeamIdCard(idCard) {
      if (this.rr_user.is_show_data === 'Y') {
        return idCard;
      }
      return idCard && idCard.length >= 6
        ? `****${idCard.substring(idCard.length - 4)}`
        : `***${idCard || ''}`;
    },
    maskTeamMobileNumber(mobileNumber) {
      if (this.rr_user.is_show_data === 'Y') {
        return mobileNumber;
      }
      return mobileNumber && mobileNumber.length >= 8
        ? `${mobileNumber.slice(0, 8)}***`
        : `${mobileNumber || ''}***`;
    },
    initialize() {
      OmiseCard = window.OmiseCard;
      OmiseCard.configure({
        publicKey: this.opn_pk,
        currency: "thb",
        frameLabel: "RUNRACE.IN.TH",
        frameDescription: "Invoice No #" + this.$route.params.q,
        image: "https://runrace.in.th/favicon.png",
        buttonLabel: "PAY NOW",
        submitLabel: "PAY NOW",
      });
    },
    async ccpayment() {
      OmiseCard.configure({
        defaultPaymentMethod: "credit_card", //credit_card promptpay truemoney
        otherPaymentMethods: [],
      });

      let _amt = "";
      //_amt = this.amount.replace(".", "");
      _amt = this.order_obj.paid_amount.replace(".", "");
      OmiseCard.configureButton("#checkout-button", {
        amount: _amt,
      });

      OmiseCard.attach();

      await OmiseCard.open({
        amount: _amt,
        submitFormTarget: "#checkout-form",
        onCreateTokenSuccess: async (nonce) => {
          //console.log("nonce", nonce);
          /* Handler on token or source creation.  Use this to submit form or send ajax request to server */
          //call create order v3
          let data = {
            token_key: nonce,
            uuid: this.$route.params.q,
            email: this.order_obj.email,
            mobile: this.order_obj.mobile,
            paid_amount: _amt,
            sk: this.sk_summarize,
            payment_method: this.order_obj.payment_method	
          };
          //loading กรุณาย่าปิดหน้าจนกว่าจะ process สำเร็จ
          this.is_payying = "Y";
          //console.log("data:" + JSON.stringify(data));
          const response = await axios.post("/v1/order/cc-payment", data);
          //console.log("response " + JSON.stringify(response));
          if (response.data.status === "success") {
            //console.log("authorize_uri: "+response.data.data.authorize_uri)
            if(response.data.data.authorize_uri !== null){
              window.location.href = response.data.data.authorize_uri;
            }else{
              alert("พบข้อผิดพลาดกรุณาติดต่อผู้ดูแลระบบ RUNRACE.IN.TH");
              this.is_payying = "N";
            }
          } else {
            this.is_payying = "N";
            await Swal.fire({
              position: "top-center",
              icon: "error",
              title:
                "พบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง, หรือติดต่อลูกค้าสัมพันธ์ที่ LINEID @ishootrun.in.th",
              showConfirmButton: true,
            });
            //console.log("response ", response);
          }
        },
        onFormClosed: (e) => {
          /* Handler on form closure. */
          //console.log("onFormClosed e", JSON.stringify(e));
        },
        onabort: (e) => {
          //console.log("onabort e", JSON.stringify(e));
        },
      });
    },
    async submit_refund_request(){
      if(this.refund_account_name === null || this.refund_account_name.length <3){
        alert("กรุณาป้อน ชื่อบัญชี ให้ถูกต้อง");
        document.getElementById('refund_account_name').focus();
        return;
      }
      if(this.refund_account_no === null || this.refund_account_no.length <6){
        alert("กรุณาป้อน หมายเลขบัญชี ให้ถูกต้อง");
        document.getElementById('refund_account_no').focus();
        return;
      }
      if(this.refund_account_bank === null){
        alert("กรุณาเลือก ชื่อธนาคาร");
        document.getElementById('refund_account_bank').focus();
        return;
      }
      if(this.refund_mobile_no === null || this.refund_mobile_no.length <10){
        alert("กรุณาป้อน หมายเลขโทรศัพท์ ให้ถูกต้อง");
        document.getElementById('refund_mobile_no').focus();
        return;
      }
      //if(confirm("กรุณาตรวจสอบความถูกต้องระบบจะอนุญาติให้บันทึกข้อมูลได้เพียงครั้งเดียว ไม่สามารถแก้ไขได้ ยืนยันการขอคืนเงิน ใช่หรือไม่ ?")){
      await Swal.fire({confirmButtonText: 'ยืนยันการขอคืนเงิน',
        title: 'กรุณาตรวจสอบความถูกต้องระบบจะอนุญาติให้บันทึกข้อมูลได้เพียงครั้งเดียว ไม่สามารถแก้ไขได้',
        text: "ยืนยันการขอคืนเงิน ใช่หรือไม่ ?", 
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true,
      }).then( async (result) => {
        if (result.isConfirmed) {
          //await this.process_submit_refund_request();
          console.log("submit_refund_request");

        const data = {
          tk: process.env.VUE_APP_FN_TO_BK_SECRET_KEY,
          order_id: this.order_obj.id,
          order_uuid: this.order_obj.uuid,
          event_key: this.order_obj.event_key,
          refund_account_name: this.refund_account_name,
          refund_account_no: this.refund_account_no,
          refund_account_bank: this.refund_account_bank,
          refund_mobile_no: this.refund_mobile_no,
          refund_remark: this.refund_remark,
          refund_amount: this.refund_amount,
        };

      
        const res = await axios.patch("/v1/order/refund-request", data);
        //console.log("res:" + JSON.stringify(res));
        if (res.data.status === "success") {
          await Swal.fire({
            position: "top-center",
            icon: "success",
            title:
              "ระบบบันทึกคำขอคืนเงินเรียบร้อยแล้ว",

            showConfirmButton: true,
          });
          location.reload();
        } else {
          await Swal.fire({
            position: "top-center",
            icon: "error",
            title:
              "พบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง, หรือติดต่อลูกค้าสัมพันธ์ที่ RUNRACE",
            showConfirmButton: true,
          });
        }
      }
      });
    },
    async upload_slip() {

      var fileSlip = document.getElementById("fileSlip");
      if (fileSlip.files.length === 0) {
        alert("กรุณาเลือกไฟล์สลิป ก่อนบันทึกข้อมูล การชำระเงิน!");
        
        document.getElementById('fileSlip').focus();
        return;
      }
      if(this.payment_slip_time === null || this.payment_slip_time === '' || this.payment_slip_time.length !==5){
        alert("กรุณาป้อน เวลาชำระเงิน ในรูปแบบ HH:MM เช่น 14:30 !");
        document.getElementById('payment_slip_time').focus();
        return;
      }
      //console.log("uploadSlip");
      //var file_slip = fileSlip.files[0].size / 1000000;
      //console.log("fileInput size mb:" + file_slip);
      if (
        fileSlip.files[0].type === "image/jpeg" || fileSlip.files[0].type === "image/png"
      ) {
        var formdata = new FormData();

        formdata.append("file", fileSlip.files[0], fileSlip.files[0].name);
        formdata.append("order_uuid", this.order_obj.uuid);
        formdata.append("event_key", this.order_obj.event_key);
        formdata.append("order_id", this.order_obj.id);
        formdata.append("payment_slip_time",this.payment_slip_time);

        // Set uploading state
        this.isUploading = true;
        this.uploadProgress = 0;

        // Use XMLHttpRequest for progress tracking
        const xhr = new XMLHttpRequest();

        // Track upload progress
        xhr.upload.addEventListener('progress', (e) => {
          if (e.lengthComputable) {
            this.uploadProgress = Math.round((e.loaded / e.total) * 100);
          }
        });

        // Handle completion
        xhr.addEventListener('load', () => {
          this.isUploading = false;
          if (xhr.status === 201) {
            const result = JSON.parse(xhr.responseText);
            alert("The file upload is completed.");
            location.reload();
          } else {
            Swal.fire({
              position: "top-center",
              icon: "error",
              title: "พบข้อผิดพลาดในการอัปโหลด กรุณาลองใหม่อีกครั้ง",
              showConfirmButton: true,
            });
          }
        });

        // Handle errors
        xhr.addEventListener('error', () => {
          this.isUploading = false;
          this.uploadProgress = 0;
          Swal.fire({
            position: "top-center",
            icon: "error",
            title: "พบข้อผิดพลาดในการอัปโหลด กรุณาลองใหม่อีกครั้ง",
            showConfirmButton: true,
          });
        });

        // Send request
        xhr.open("POST", process.env.VUE_APP_RUNNING_API + "/v1/upload/slip");
        xhr.send(formdata);
      } else {
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: "กรุณาเลือกไฟล์ jpg หรือ png เท่านั้น",
          showConfirmButton: true,
          timer: 7000,
        });
      }
      //call service and upload to s3
    },

    async shareOrderLink() {
      const shareData = {
        title: this.currentLanguage === 'en' ? 'RUNRACE Order' : 'ใบสมัคร RUNRACE',
        text: this.currentLanguage === 'en' ? 'Open this order page' : 'เปิดลิงก์ใบสมัครนี้',
        url: this.qr_code,
      };

      try {
        if (navigator.share) {
          await navigator.share(shareData);
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.qr_code);
          await Swal.fire({
            position: 'top-center',
            icon: 'success',
            title: this.currentLanguage === 'en' ? 'Link copied to clipboard' : 'คัดลอกลิงก์เรียบร้อย',
            showConfirmButton: true,
          });
          return;
        }

        await Swal.fire({
          position: 'top-center',
          icon: 'info',
          title: this.currentLanguage === 'en' ? 'Please copy this link manually' : 'กรุณาคัดลอกลิงก์ด้วยตนเอง',
          text: this.qr_code,
          showConfirmButton: true,
        });
      } catch (error) {
        if (error && error.name === 'AbortError') {
          return;
        }
        await Swal.fire({
          position: 'top-center',
          icon: 'error',
          title: this.currentLanguage === 'en' ? 'Unable to share right now' : 'ไม่สามารถแชร์ได้ในขณะนี้',
          showConfirmButton: true,
        });
      }
    },
    


    drawImage(context, image, x, y, width, height, radius = 5) {
      context.shadowOffsetX = 0;
      context.shadowOffsetY = 0;
      context.shadowBlur = 0;
      context.shadowColor = "#00000040";
      context.lineWidth = 25;
      context.beginPath();
      context.moveTo(x + radius, y);
      context.arcTo(x + width, y, x + width, y + height, radius);
      context.arcTo(x + width, y + height, x, y + height, radius);
      context.arcTo(x, y + height, x, y, radius);
      context.arcTo(x, y, x + width, y, radius);
      context.closePath();
      context.strokeStyle = "#fff";
      context.stroke();
      context.clip();
      context.fillStyle = "#fff";
      context.fillRect(x, y, width, height);
      context.drawImage(image, x, y, width, height);
    },
  },
};
</script>

<style scoped>
.receipt-download-button {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 40px;
  padding: 7px 15px 7px 8px;
  color: #ffffff;
  background: #5f6670;
  border: 1px solid #5f6670;
  border-radius: 6px;
  box-shadow: 0 5px 12px rgba(54, 62, 72, 0.22);
  font-weight: 600;
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.receipt-download-button:hover:not(:disabled) {
  color: #ffffff;
  background: #2f343a;
  border-color: #2f343a;
  box-shadow: 0 7px 16px rgba(54, 62, 72, 0.28);
  transform: translateY(-1px);
}

.receipt-download-button:focus-visible {
  color: #ffffff;
  background: #5f6670;
  border-color: #5f6670;
  box-shadow: 0 0 0 3px rgba(95, 102, 112, 0.24);
}

.receipt-download-button:disabled {
  color: #7a8799;
  background: #edf1f6;
  border-color: #d6dee9;
  box-shadow: none;
  cursor: not-allowed;
}

.receipt-download-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #5f6670;
  background: #ffffff;
  border-radius: 50%;
}

.receipt-download-button:disabled .receipt-download-icon {
  color: #7a8799;
  background: #dfe6ef;
}

.organizer-info-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.organizer-info-content {
  min-width: 0;
}

.receipt-page-note {
  flex: 0 1 430px;
  margin: 0 0 0 auto;
  padding: 0 14px;
  color: #6a7280;
  font-size: 10px;
  line-height: 1.55;
  text-align: right;
}

@media (max-width: 576px) {
  .organizer-info-row {
    display: block;
  }

  .receipt-page-note {
    margin-top: 12px;
  }
}

.receipt-pdf {
  position: fixed;
  top: 0;
  left: -10000px;
  width: 794px;
  box-sizing: border-box;
  padding: 56px;
  color: #111827;
  background: #ffffff;
  font-family: Tahoma, "Noto Sans Thai", sans-serif;
  font-size: 13px;
  line-height: 1.65;
}

.receipt-pdf-header {
  padding-bottom: 20px;
  margin-bottom: 24px;
  text-align: center;
  border-bottom: 2px solid #1d4ed8;
}

.receipt-pdf-header h2,
.receipt-pdf-header h3,
.receipt-pdf-header p {
  margin: 0;
}

.receipt-pdf-header h2 {
  font-size: 17px;
}

.receipt-pdf-header p {
  font-size: 11px;
}

.receipt-pdf-header h3 {
  margin-top: 6px;
  font-size: 15px;
  font-weight: 600;
}

.receipt-pdf-row {
  display: flex;
  justify-content: space-between;
  gap: 32px;
  padding: 8px 0;
  border-bottom: 1px solid #e5e7eb;
}

.receipt-pdf-total {
  margin-top: 12px;
  font-size: 14px;
  border-bottom: 2px solid #1d4ed8;
}

.receipt-pdf-note {
  padding: 18px;
  margin-top: 30px;
  background: #f8fafc;
  border-left: 4px solid #1d4ed8;
}

.receipt-pdf-signature {
  margin-top: 32px;
  text-align: center;
}

.receipt-signature-image {
  display: inline-block;
  width: 140px;
  height: 56px;
  margin: -18px 8px -16px;
  object-fit: contain;
  vertical-align: middle;
}

.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.completed .step-counter {
  background-color: #66b5ff;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #66b5ff;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}

.stepper-item:last-child::after {
  content: none;
}

.align-to-right {
  float: none;
  margin: 0 auto;
  padding: 0;
  background: transparent;
}

.payment-summary-table {
  width: min(640px, 100%);
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
  background: #ffffff;
  border: 1px solid #dbe6f4;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(21, 64, 126, 0.08);
}

.payment-summary-table tbody tr {
  background: #ffffff;
}

.payment-summary-table th {
  border: 0;
  border-bottom: 1px dashed #d7e2f2;
  padding: 12px 16px;
  vertical-align: middle;
}

.payment-label {
  width: 50%;
  text-align: right;
  color: #445f86;
  font-weight: 500;
}

.payment-value {
  width: 50%;
  text-align: left;
  color: #173a71;
  font-weight: 700;
}

.payment-total-row {
  background: linear-gradient(135deg, #1d4f96 0%, #2d6fc7 100%) !important;
}

.payment-total-row th {
  background: linear-gradient(135deg, #1d4f96 0%, #2d6fc7 100%) !important;
  color: #ffffff !important;
  border-bottom: 0 !important;
  font-size: 1.06rem;
}

.payment-total-row .payment-label,
.payment-total-row .payment-value {
  color: #ffffff !important;
}

.qr-panel {
  margin: 14px auto 24px;
  max-width: 560px;
  padding: 20px 18px 22px;
  border-radius: 18px;
  border: 1px solid #d4e2f7;
  background:
    radial-gradient(circle at 20% 0%, rgba(61, 137, 255, 0.14), rgba(61, 137, 255, 0) 34%),
    linear-gradient(170deg, #fbfdff 0%, #eef4ff 100%);
  box-shadow: 0 14px 30px rgba(22, 61, 120, 0.14);
  text-align: center;
}

.qr-panel-title {
  margin-bottom: 4px;
  color: #103668;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.qr-panel-subtitle {
  margin-bottom: 10px;
  color: #50678b;
  font-size: 0.92rem;
}

.qr-panel-link {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 12px;
  padding: 7px 12px;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid #cadcf8;
  color: #194987;
  font-weight: 600;
  font-size: 0.88rem;
  word-break: break-all;
  text-decoration: none;
}

.qr-panel-link:hover {
  background: #f1f6ff;
  color: #123f77;
}

.qr-panel-canvas {
  display: flex;
  justify-content: center;
}

.qr-panel-canvas-inner {
  background: #ffffff;
  border: 1px solid #cfdcf1;
  border-radius: 14px;
  padding: 10px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.8);
}

.qr-panel-actions {
  margin-bottom: 14px;
}

.qr-share-btn {
  border-radius: 999px;
  padding: 6px 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 4px 10px rgba(22, 88, 183, 0.25);
}

.order-skeleton-wrap {
  width: 100%;
}

.order-skeleton {
  border-radius: 10px;
  background: linear-gradient(90deg, #e9eef5 20%, #f7faff 50%, #e9eef5 80%);
  background-size: 220px 100%;
  animation: orderSkeletonShimmer 1.2s infinite linear;
}

.order-skeleton-cover {
  width: 100%;
  height: 230px;
  border-radius: 12px;
}

.order-skeleton-step {
  width: 100%;
  height: 44px;
}

.order-skeleton-title {
  width: 48%;
  height: 30px;
}

.order-skeleton-line {
  width: 100%;
  height: 18px;
}

.order-skeleton-line-short {
  width: 55%;
}

.order-skeleton-status {
  width: 220px;
  height: 32px;
}

@keyframes orderSkeletonShimmer {
  0% {
    background-position: -220px 0;
  }
  100% {
    background-position: 220px 0;
  }
}

@media (max-width: 576px) {
  .qr-panel {
    padding: 14px 12px 18px;
    border-radius: 14px;
  }

  .qr-panel-subtitle {
    font-size: 0.88rem;
  }

  .payment-summary-table th {
    padding: 10px 12px;
  }

  .payment-label {
    display: table-cell;
    width: 50%;
    text-align: right;
    white-space: nowrap;
  }

  .payment-value {
    display: table-cell;
    width: 50%;
    text-align: left;
    white-space: nowrap;
  }

  .payment-summary-table {
    border-radius: 12px;
  }

  .order-skeleton-cover {
    height: 150px;
  }

  .order-skeleton-title {
    width: 80%;
  }

  .order-skeleton-status {
    width: 160px;
  }
}

input[type="checkbox"] {
  display: none;
}
</style>